import { appWithTranslation } from 'next-i18next'
import type { AppProps } from 'next/app'
import type { ComponentType, PropsWithChildren } from 'react'
import nextI18NextConfig from '../../next-i18next.config.js'

type TranslatorProps = PropsWithChildren<Pick<AppProps, 'pageProps'>>

const TranslatorRaw = ({ children }: TranslatorProps) => {
  return <>{children}</>
}

export const Translator: any = appWithTranslation(
  TranslatorRaw as ComponentType<any>,
  nextI18NextConfig
)
